import {useEffect} from 'react';
import SwitchLang from '@/components/SwitchLang';
import {handleCanceledAccount, useGetCampaign} from '@/helper';
import {initMonitor} from '@/util';
import Logo from '@/assets/logo.svg?react';
import RightWrap from '../Core/RightWrap';
import {initPass, initUC} from './pc-init';
import './styles';

export default function App() {
    const year = new Date().getFullYear();
    useEffect(() => {
        useGetCampaign();
        initMonitor();
        handleCanceledAccount();
    }, []);
    return (
        <>
            <div className="page-wrap">
                <div className="choice-language" id="choice-language">
                    <SwitchLang />
                </div>
                <div className="left-wrap">
                    <div className="header_wrap">
                        <a href="https://cloud.baidu.com/" className="logo-wrap">
                            <Logo />
                        </a>
                    </div>
                    <div className="first-slogan">百度智能云 云智一体深入产业</div>
                    <div className="second-slogan">
                        聚焦行业核心场景，打造行业标杆应用 <br />
                        全栈自研的AI大底座，满足产业对智算基础设施的需求
                        <br />
                        先进的技术和丰富的解决方案，与实体经济深度融合，共创价值
                        <br />
                    </div>
                    <div className="divide-line"></div>
                    <a id="campaign" className="campaign-link" href="https://cloud.baidu.com/">
                        <img className="banner" src="/img/banner@2x.png" />
                    </a>
                    <div className="copy-that">
                        ©{year} Baidu&nbsp;
                        <a href="http://www.baidu.com/duty/" target="_blank" rel="noreferrer">
                            使用百度前必读
                        </a>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <a href="https://cloud.baidu.com/qualification/isp.html" target="_blank" rel="noreferrer">
                            增值电信业务经营许可证：B1.B2-20100266
                        </a>
                        <br />
                        京ICP证030173号&nbsp;&nbsp;&nbsp;&nbsp;
                        <a target="blank" href="https://cloud.baidu.com/doc/Agreements/s/Kjwvy245m/">
                            隐私政策
                        </a>
                    </div>
                </div>
                <RightWrap extraClassName="" initPass={initPass} initUC={initUC} />
            </div>
        </>
    );
}
